/* eslint-disable */
import { isRejectedWithValue } from '@reduxjs/toolkit';

const APIErrorHandler = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (action.payload.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  }
  return next(action);
};

export default APIErrorHandler;
